import React from "react";
import Radio from 'antd/lib/radio';

const RadioBtn = ({label}) => <Radio>{label}</Radio>

RadioBtn.defaultProps = {
    label: 'default'
}

export default RadioBtn;